import React from "react";
import DescriptionList from "../Shared/DescriptionList";
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  ChatBubbleLeftIcon 
} from "@heroicons/react/24/outline";

const ContactClient = ({ client }) => {
  const { clientFullName, clientEmail, clientPhoneNumber } = client;

  const ContactButton = ({ href, icon: Icon, label, colorClass = "bg-accent-500 hover:bg-accent-400" }) => (
    <a
      href={href}
      className={`w-8 h-8 ${colorClass} text-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-200`}
      title={label}
      aria-label={label}
    >
      <Icon className="w-4 h-4" />
    </a>
  );

  const emailField = clientEmail ? (
    <div className="pr-4">
      <div className="flex items-center justify-between">
        <span className="text-ink-700 mr-3">{clientEmail}</span>
        <div className="flex gap-2">
          <ContactButton
            href={`mailto:${clientEmail}`}
            icon={EnvelopeIcon}
            label="Send Email"
          />
        </div>
      </div>
    </div>
  ) : null;

  const phoneField = clientPhoneNumber ? (
    <div className="pr-4">
      <div className="flex items-center justify-between">
        <span className="text-ink-700 mr-3">{clientPhoneNumber}</span>
        <div className="flex gap-2">
          <ContactButton
            href={`tel:${clientPhoneNumber}`}
            icon={PhoneIcon}
            label="Call"
            colorClass="bg-signal-green-500 hover:bg-signal-green-600"
          />
          <ContactButton
            href={`sms:${clientPhoneNumber}`}
            icon={ChatBubbleLeftIcon}
            label="Send Text"
            colorClass="bg-accent-500 hover:bg-accent-400"
          />
        </div>
      </div>
    </div>
  ) : null;

  const contactFields = [
    { label: "Name", value: clientFullName },
    { label: "Email", value: emailField },
    { label: "Phone", value: phoneField }
  ].filter(field => field.value);

  return <DescriptionList items={contactFields} />;
};

export default ContactClient;